module.exports = __webpack_public_path__ + "static/media/failed.1c0b3233.svg";